import { __assign } from 'tslib';
import PropTypes from 'prop-types';
import { propTypes as propTypes$1 } from '../Icon/Icon.types.js';
import * as index from '../Icon/icons/index.js';

/**
 * @deprecated
 * We no longer use enums for props (so that we don't force the user to import the enum).
 * This enum will remain here for backwards compatibility purposes.
 */
var Variants;
(function (Variants) {
    Variants["PRIMARY"] = "primary";
    Variants["SECONDARY"] = "secondary";
    Variants["TERTIARY"] = "tertiary";
    Variants["DANGER"] = "danger";
})(Variants || (Variants = {}));
var propTypes = __assign(__assign({}, propTypes$1), { href: PropTypes.string, onClick: PropTypes.func, disableBorder: PropTypes.bool, isSelected: PropTypes.bool, iconClassname: PropTypes.string, buttonProps: PropTypes.object, variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'danger']), buttonSize: PropTypes.oneOf(['regular', 'large']), dataTestId: PropTypes.string, 'data-testid': PropTypes.string, isLoading: PropTypes.bool });
var defaultProps = {
    color: '',
    buttonProps: {},
    iconSet: index,
    variant: 'primary',
};

export { Variants, defaultProps, propTypes };
